import { render, staticRenderFns } from "./overview_table.vue?vue&type=template&id=4bcb06ae&scoped=true"
import script from "./overview_table.vue?vue&type=script&lang=js"
export * from "./overview_table.vue?vue&type=script&lang=js"
import style0 from "./overview_table.vue?vue&type=style&index=0&id=4bcb06ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb06ae",
  null
  
)

export default component.exports